import { IBaseVariables } from './baseVariables';

export interface IGetComboboxGroup extends IBaseVariables {
  groupId?: string;
}

export interface IGetComboboxJobTitle extends IBaseVariables {
  jobName?: string;
}

export interface IGetComboboxJobTitleNew extends IBaseVariables {
  jobTitle?: string;
  jobTitleName?: string;
}

export interface IGetGroupRole {
  page: number;
  pageSize: number;
  plantId?: string;
  unit?: string;
  jobTitle?: string;
  rewardId?: string;
  groupId?: string;
  status?: string;
  headerRow?: any;
  type?: string;
}

export interface IUpdateGroupRoleManagementStatus {
  id: string;
  status: boolean;
}

export interface IUpdateGroupRoleManagement {
  id: string;
  rewardId: string;
  jobTitle: string;
  jobTitleName: string;
  plantId: string;
  unitId1: string;
  unitName1: string;
  unitId2: string;
  unitName2: string;
  unitId3: string;
  unitName3: string;
  unitId4: string;
  unitName4: string;
  groupId: string;
  rewardStatus: boolean;
  status: boolean;
}

export const GroupRoleVariables = {
  getGroupRole: (params: IGetGroupRole) => {
    const {
      page,
      pageSize,
      plantId,
      unit,
      jobTitle,
      groupId,
      status,
      rewardId,
    } = params;
    return {
      skip: (page - 1) * pageSize,
      take: pageSize,
      input: {
        ...(plantId && {
          plantId: {
            equals: plantId,
          },
        }),
        jobTitle: {
          equals: jobTitle,
        },
        groupId: {
          equals: groupId,
        },
        ...(status && { status: { equals: status === 'R100_01' } }),
        ...(rewardId && { rewardId: { equals: rewardId } }),
        OR: [
          {
            unitId1: {
              contains: unit,
            },
          },
          {
            unitName1: {
              contains: unit,
            },
          },
          {
            unitId2: {
              contains: unit,
            },
          },
          {
            unitName2: {
              contains: unit,
            },
          },
          {
            unitId3: {
              contains: unit,
            },
          },
          {
            unitName3: {
              contains: unit,
            },
          },
          {
            unitId4: {
              contains: unit,
            },
          },
          {
            unitName4: {
              contains: unit,
            },
          },
        ],
      },
    };
  },
  saveGroupRole: (params: any) => {
    return {
      input: {},
    };
  },
  getCbxUnitLevel: (params: any) => {
    return {};
  },
  getCbxPosition: (params: any) => {
    return {};
  },
  getCbxStaus: (params: any) => {
    return {};
  },
  getCbxObject: (params: any) => {
    return {};
  },
  getCbxGroup: (params: any) => {
    return {};
  },
  //   Get combobox Group
  getComboboxGroup: ({ skip, take, groupId }: IGetComboboxGroup) => {
    return {
      skip,
      take,
      input: {
        OR: [
          {
            id: {
              contains: groupId,
            },
          },
          {
            name: {
              contains: groupId,
            },
          },
        ],
      },
    };
  },
  // Get combobox Job title
  getComboboxJobTitle: ({ skip, take, jobName }: IGetComboboxJobTitle) => {
    return {
      skip,
      take,
      input: {
        ...(jobName && {
          OR: [
            { id: { contains: jobName } },
            { jobName: { contains: jobName } },
          ],
        }),
      },
    };
  },
  getComboboxJobTitleNew: ({
    skip,
    take,
    jobTitle,
    jobTitleName,
  }: IGetComboboxJobTitleNew) => {
    const listFilter = [
      ...(jobTitle ? [{ jobTitle: { contains: jobTitle } }] : []),
      ...(jobTitleName ? [{ jobTitleName: { contains: jobTitleName } }] : []),
    ];

    return {
      skip,
      take,
      input: {
        ...(listFilter.length > 0 && { OR: listFilter }),
      },
    };
  },
  updateGroupRoleManagementStatus: (
    input: IUpdateGroupRoleManagementStatus,
  ) => {
    return {
      input,
    };
  },
  updateGroupRoleManagement: (input: IUpdateGroupRoleManagement) => {
    return {
      input,
    };
  },
};
